import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle } from 'lucide-react';

const About = () => {
  const { t } = useTranslation();

  const reasons = [
    t('about.reason1'),
    t('about.reason2'),
    t('about.reason3'),
    t('about.reason4')
  ];

  return (
    <div className="page-about">
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">{t('about.title')}</h1>
          <p className="page-subtitle">{t('about.intro')}</p>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <div className="about-grid">
            <div className="about-image">
              <img 
                src="https://customer-assets.emergentagent.com/job_edge-marine-corp/artifacts/4cziy0ew_WhatsApp%20Image%202026-02-05%20at%2019.24.02%20%284%29.jpeg" 
                alt="Marine Electrical Cable Routing and Segregation"
                className="rounded-image"
              />
            </div>
            <div className="about-text">
              <p className="about-paragraph">{t('about.paragraph1')}</p>
              <p className="about-paragraph">{t('about.paragraph2')}</p>
              <p className="about-paragraph">{t('about.paragraph3')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="why-section">
        <div className="container">
          <h2 className="section-title">{t('about.why')}</h2>
          <div className="why-grid">
            {reasons.map((reason, index) => (
              <div key={index} className="why-card">
                <CheckCircle className="why-icon" />
                <p>{reason}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="expertise-section">
        <div className="container">
          <div className="expertise-images-two">
            <img 
              src="https://customer-assets.emergentagent.com/job_edge-marine-corp/artifacts/hkdpc01b_WhatsApp%20Image%202026-02-05%20at%2019.24.02%20%286%29.jpeg" 
              alt="Marine Electrical Cable Routing Systems"
              className="expertise-img"
            />
            <img 
              src="https://customer-assets.emergentagent.com/job_edge-marine-corp/artifacts/60ti4un6_WhatsApp%20Image%202026-02-05%20at%2019.24.02%20%285%29.jpeg" 
              alt="Power Distribution Panel Installation"
              className="expertise-img"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
